import {Routes} from '@angular/router';
import {LandingPageComponent} from './landing-page/landing-page.component';
import {EventCalendarComponent} from './event/event-calendar/event-calendar.component';
import {RegistrationComponent} from './user/registration/registration.component';
import {LoginComponent} from './user/login/login.component';
import {FulfillmentListComponent} from './fulfillment-list/fulfillment-list.component';

export const routes: Routes = [
    {path: '', redirectTo: '/landing', pathMatch: 'full'},
    {path: 'landing', component: LandingPageComponent},
    {path: 'calendar', component: EventCalendarComponent},
    {path: 'registration', component: RegistrationComponent},
    {path: 'login', component: LoginComponent},
    {path: 'fulfillment-list', component: FulfillmentListComponent},
];
